import { InferFormValues } from '../../FormComponent/types'
import { ContentDataType, FieldDefinition, UISchema } from '../types-v6'
import { Button } from '@/components/shadcn/button'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconEditOutline } from '@icons/IconEditOutline'
import { SheetWithFormSchema } from '@/components/ui/SheetWithFormSchema'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { uiSchemaToFormSchema } from '../utils'

export function ContentEditorActions({
  canEditContent,
  canDeleteContent,
  uiSchema,
  handlerId: handlerIdProp,
  content,
  parentId,
}: {
  canEditContent: boolean
  canDeleteContent: boolean
  uiSchema: UISchema | FieldDefinition
  content?: ContentDataType
  handlerId?: string
  parentId?: string
}) {
  const { tileFilterSelections } = useTileFilters()
  const handlerId = handlerIdProp || ''
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(handlerId, tileFilterSelections)
  if (!canEditContent && !canDeleteContent) return null
  if (!uiSchema) return null
  const formSchema = uiSchemaToFormSchema(uiSchema, content)
  return (
    <div className="flex">
      {canEditContent && (
        <SheetWithFormSchema
          triggerTooltip="Edit Content"
          trigger={
            <Button size="icon" variant="ghost">
              <IconEditOutline size={16} />
            </Button>
          }
          schema={formSchema}
          closeOnSuccess
          onSubmit={(data: InferFormValues<typeof formSchema>, onSuccess) => {
            const dataToSubmit = content
              ? parentId
                ? { ...data, id: content.id, parentId }
                : { ...data, id: content.id }
              : data
            // Call submitForm with the data and pass the onSuccess callback to be executed only on success
            submitForm(dataToSubmit, {
              onSuccess: () => {
                if (onSuccess) {
                  onSuccess()
                }
              },
            })
          }}
          isSubmitting={isSubmitting}
        />
      )}
      {canDeleteContent && (
        <Button size="icon" variant="ghost">
          <IconDeleteOutline size={16} />
        </Button>
      )}
    </div>
  )
}
